<template>

  <button type="button" class="btn btn-sm btn-outline-info" data-bs-toggle="modal"
          data-bs-target="#modalProjectFileHistory" @click="openModal">
    <i class="bi bi-clock-history"></i>&nbsp; Historia zmian
  </button>

  <!-- Modal -->
  <div class="modal fade" id="modalProjectFileHistory" tabindex="-1" role="dialog" @click.self="closeModal"
       aria-labelledby="modelTitleId" aria-hidden="true" ref="modalHistory">
    <div class="modal-dialog modal-full-width" role="document">
      <div class="modal-content" ref="modalProjectFileHistoryContentRef">
        <div class="modal-header">
          <h5 class="modal-title">Ostatnie zmiany w pliku projektu</h5>
          <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body table-responsive text-start">

          <div class="row mt-3">
            <div class="col-sm-12">

              <div v-if="isLoading">
                <div class="position-absolute w-100 h-100 text-center" style="z-index: 9">
                  <div class="spinner-border text-danger me-2 align-self-center loader-lg" style="top:20%"></div>
                </div>
              </div>

              <div :style="{ opacity: isLoading ? '0.4' : '1' }">
                <ejs-grid id="GridProjectFileHistory" ref="gridProjectFileHistory"
                          gridLines="Both"
                          height='100%'
                          :allowExcelExport='true'
                          :dataSource="projectFileHistoryData"
                          :allowPaging="true"
                          :allowFiltering="true"
                          :filterSettings="filterOptions"
                          :allowSorting="true"
                          :sortSettings="sortSettings"
                          :pageSettings='pageSettings'
                          :allowReordering='true'
                          :allowResizing='true'
                          :allowTextWrap="true"
                          :toolbar='toolbar'
                          :rowDataBound="onRowDataBound"
                          :toolbarClick="toolbarClick">
                  <e-columns>
                    <e-column field='original_id' headerText='ID' width="95"></e-column>
                    <e-column field="topic" headerText="Temat" type="string"></e-column>
                    <e-column field="priority" type="number" headerText="Priorytet"></e-column>
                    <e-column field="topic2" type='string' headerText="Temat"></e-column>
                    <e-column field="person_responsible_for" headerText="Osoba odpowiedzialna"
                              type="string"></e-column>
                    <e-column field="resolution_steps" type='string'
                              headerText="Kroki podjęte do rozwiązania problemu"></e-column>
                    <e-column field="meeting_date" headerText="Data spotkania" type="date"
                              format='dd.MM.yyyy'></e-column>
                    <e-column field="percentages" headerText="%" type='string' width="70"></e-column>
                    <e-column field="status" headerText="Status" type="string"></e-column>
                    <e-column field="additional_points" type='string' headerText="Dodatkowe punkty"></e-column>
                    <e-column field="correspondence_url" headerText="Url" type='string'></e-column>
                    <e-column field='created_by_name' headerText='Stworzył'></e-column>
                    <e-column field='updated_by_name' headerText='Aktualizował'></e-column>
                    <e-column field='updated_at' type="date" format="dd.MM.yyyy" headerText='Data Aktualizacji'/>
                    <e-column field='deleted_at' type="date" format="dd.MM.yyyy" headerText='Data Usunięcia'/>
                  </e-columns>
                </ejs-grid>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  Edit, ExcelExport,
  Filter,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Sort,
  Toolbar
} from '@syncfusion/ej2-vue-grids';

import GraphProjectFileProgress from "../../../Components/Widgets/Graphs/GraphProjectFileProgress.vue";

export default {
  components: {
    GraphProjectFileProgress,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },

  props: {
    projectId: Number,
  },

  data() {
    return {
      isOpened: false,
      isLoading: false,
      projectFileHistoryData: {},
      filterOptions: {type: "Excel"},
      sortSettings: {columns: [{field: 'updated_at', direction: 'Descending'}]},
      pageSettings: {pageSize: 50, pageCount: 5, pageSizes: [10, 20, 50, 100, 200]},
      toolbar: [
        {text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right'},
        {text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right'},
      ]
    }
  },

  watch: {
    isOpened(newVal) {
      if (newVal === true) {
        this.getHistoryData();
      }
    }
  },

  methods: {
    async getHistoryData() {
      this.isLoading = true;
      try {
        const response = await axios.post(route('projects.project-history.getHistoryForProjectFile', {project: this.projectId}));
        this.projectFileHistoryData = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    onRowDataBound(args) {
      if (args.data.deleted_at) {
        args.row.classList.add('soft-deleted-row');
      }
    },

    toolbarClick(args) {
      if (args.item.id === 'restore') {
        let grid = this.$refs.gridProjectFileHistory;
        let gridName = 'grid' + grid.$el.id;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
        location.reload();
      }

      if (args.item.id === 'excelexport') {
        this.$refs.gridProjectFileHistory.excelExport({
          fileName: `${this.project.number}-plik projektu.xlsx`
        });
      }
    },

    openModal() {
      this.isOpened = true;

      const modalEl = this.$refs.modalHistory;
      modalEl.addEventListener('hide.bs.modal', () => {
        this.isOpened = false;
      }, {once: true});
    },

    closeModal() {
      this.projectFileHistoryData = {};
      this.isOpened = false;
    }
  }
}
</script>

<style scoped>
:deep(.soft-deleted-row) {
  text-decoration: line-through;
  opacity: 0.8;
}
</style>